"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDrDashAppName = exports.getShopperPlatformAppName = exports.getBrowserAppName = void 0;
var shopperPlatformOptions = ['AMD', 'Sales View', 'shopper-quote-dashboard', 'shopper-platform-certificate'];
var drDashOptions = ['CMD', 'Manager View'];
var getBrowserAppName = function (applicationName, environment) {
    if (shopperPlatformOptions.includes(applicationName)) {
        return (0, exports.getShopperPlatformAppName)(environment);
    }
    if (drDashOptions.includes(applicationName)) {
        return (0, exports.getDrDashAppName)(environment);
    }
};
exports.getBrowserAppName = getBrowserAppName;
var getShopperPlatformAppName = function (environment) {
    switch (environment) {
        case 'dev2':
            return 'DR ShopperPlatform (Dev2)';
        case 'dev':
            return 'DR ShopperPlatform (Dev)';
        case 'qa':
            return 'DR ShopperPlatform (QA)';
        case 'production':
            return 'DR ShopperPlatform (Prod)';
        default:
            return '';
    }
};
exports.getShopperPlatformAppName = getShopperPlatformAppName;
var getDrDashAppName = function (environment) {
    switch (environment) {
        case 'dev2':
            return 'DR Close My Deals (Dev2)';
        case 'dev':
            return 'DR Close My Deals (Dev)';
        case 'qa':
            return 'DR Close My Deals (QA)';
        case 'production':
            return 'DR Close My Deals (Prod)';
        default:
            return '';
    }
};
exports.getDrDashAppName = getDrDashAppName;
